/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FacilitySettingsSettings } from './FacilitySettingsSettings';
import {
    FacilitySettingsSettingsFromJSON,
    FacilitySettingsSettingsFromJSONTyped,
    FacilitySettingsSettingsToJSON,
} from './FacilitySettingsSettings';

/**
 * 
 * @export
 * @interface FacilitySettings
 */
export interface FacilitySettings {
    /**
     * 
     * @type {string}
     * @memberof FacilitySettings
     */
    facility_id: string;
    /**
     * 
     * @type {FacilitySettingsSettings}
     * @memberof FacilitySettings
     */
    settings: FacilitySettingsSettings;
}

/**
 * Check if a given object implements the FacilitySettings interface.
 */
export function instanceOfFacilitySettings(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "facility_id" in value;
    isInstance = isInstance && "settings" in value;

    return isInstance;
}

export function FacilitySettingsFromJSON(json: any): FacilitySettings {
    return FacilitySettingsFromJSONTyped(json, false);
}

export function FacilitySettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilitySettings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'facility_id': json['facility_id'],
        'settings': FacilitySettingsSettingsFromJSON(json['settings']),
    };
}

export function FacilitySettingsToJSON(value?: FacilitySettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'facility_id': value.facility_id,
        'settings': FacilitySettingsSettingsToJSON(value.settings),
    };
}

